const es = {
  brand: "Veyra",
  common: {
    demo: "Demo",
    demoLong: "Contenido de demostración",
    demoModeTitle: "Contenido de demostración",
    demoModeBody: "Los elementos marcados como Demo son elementos ilustrativos incluidos en el estado inicial. No representan generaciones reales ni identidad oficial de personajes o productos.",
    pending: "Integración pendiente",
    save: "Guardar",
    saved: "Guardado",
    cancel: "Cancelar",
    delete: "Eliminar",
    duplicate: "Duplicar",
    create: "Crear",
    close: "Cerrar",
    back: "Atrás",
    next: "Continuar",
    skip: "Omitir por ahora",
    finish: "Finalizar",
    open: "Abrir",
    select: "Seleccionar",
    selected: "Seleccionado",
    edit: "Editar",
    apply: "Aplicar",
    applied: "Aplicado",
    type: "Tipo",
    prompt: "Prompt",
    project: "Proyecto",
    status: "Estado",
    noProject: "Sin proyecto",
    untitled: "Sin título",
    loadError: "No se pudo cargar tu información guardada. Comprueba tu conexión e inténtalo de nuevo.",
    loadError401: "Tu sesión ha caducado. Vuelve a iniciar sesión.",
    loadErrorServer: "Error del servidor al cargar tus datos. Inténtalo de nuevo.",
    saveError: "No se pudo guardar el cambio. Comprueba tu conexión.",
    saveError401: "Tu sesión ha caducado. Los últimos cambios no se guardaron. Vuelve a iniciar sesión.",
    saveErrorServer: "Error del servidor al guardar. Inténtalo de nuevo.",
    confirm: "Confirmar",
    understood: "Entendido",
    loading: "Cargando…",
    retry: "Reintentar",
    none: "Ninguno",
    search: "Buscar",
    all: "Todos",
    untitled: "Sin título",
    id: "ID",
    createdAt: "Creado",
    updatedAt: "Actualizado",
    version: "Versión",
    original: "Original",
    prompt: "Prompt",
    references: "Referencias",
    status: "Estado",
    type: "Tipo",
    name: "Nombre",
    description: "Descripción",
    handle: "Handle",
    format: "Formato",
    project: "Proyecto",
    scenes: "Escenas",
    assets: "Activos",
    noProject: "Sin proyecto",
    noProjectHint: "El resultado se guardará en la Galería general; no se pierde.",
    notConnected: "No conectado",
    notConfigured: "Sin configurar",
    downloadSuccess: "Descarga iniciada",
    downloadError: "Error al descargar el archivo original",
    unknown: "Desconocido",
    estimated: "Estimado",
    confirmed: "Confirmado",
    remove: "Quitar",
    add: "Añadir",
    warning: "Aviso",
    comingSoon: "Próximamente",
  },
  generation: {
    completedToast: "Generación completada",
    failedToast: "La generación falló",
    submitError: "Error al enviar la generación",
    budgetInsufficient: "Presupuesto insuficiente para esta generación",
    budgetNotConfigured: "No hay límite mensual de presupuesto configurado. Define un tope en Ajustes › Presupuesto antes de generar.",
    budgetSettingsLink: "Ajustes › Presupuesto",
    uncertainState: "Estado de envío incierto: el proveedor podría haber recibido la petición. No se reenvió para evitar un segundo cargo. Consulta el estado en el panel de tareas.",
    blockedNoKey: "Sin clave API configurada. La tarea queda guardada como bloqueada.",
    maxRefs: "Máximo de referencias alcanzado para esta fase",
    providerNote: "Seedream 5.0 Pro via Apimart",
  },
  stepStatus: { completed: "Completado", skipped: "Omitido", pending: "Pendiente" },
  connections: {
    status: { not_configured: "Sin clave configurada", configured: "Clave configurada", verified: "Conexión verificada", error: "Error" },
    none: "Sin conexión",
    required: "Añade una conexión en Ajustes → Conexiones para continuar.",
    noneOperational: "Tienes conexiones creadas, pero ninguna tiene clave configurada u operativa con un modelo compatible todavía.",
    shortCount: (n) => `${n} sin configurar`,
    capabilities: { image: "Imagen", video: "Vídeo", text: "Texto", audio: "Audio/voz" },
    stages: { created: "Creada", unconfigured: "Sin configurar", unverified: "Sin verificar", operational: "Operativa" },
    lifecycleNote: "Una conexión avanza por estas etapas: Creada → Sin configurar (sin clave) → Sin verificar (clave guardada, aún no probada) → Operativa (verificada y lista).",
  },
  nav: {
    home: "Inicio",
    projects: "Proyectos",
    characters: "Personajes y referencias",
    gallery: "Galería",
    tasks: "Tareas",
    admin: "Panel Administrativo",
    settings: "Ajustes",
    onboarding: "Configuración inicial",
    workspace: "Workspace",
    collapse: "Contraer menú",
    expand: "Expandir menú",
    menu: "Menú",
    home_icon_hint: "Ir al inicio",
  },
  banners: {
    demoTitle: "Estás viendo datos de demostración",
    demoBody:
      "Las imágenes y textos marcados como Demo son elementos ilustrativos. No hay generaciones reales, ni proveedores conectados, ni identidad oficial de tus personajes o productos.",
    onboardingIncomplete: "Configuración inicial incompleta",
    onboardingResume: "Reanudar",
    noConnection: "Generación deshabilitada: no hay ninguna conexión configurada. Añade una en Ajustes → Conexiones.",
    noProvider: "Generación deshabilitada: no hay ninguna conexión configurada. Añade una en Ajustes → Conexiones.",
    localOnly:
      "Tus datos se guardan en tu base de datos, protegidos por tu sesión. Las imágenes que subas se guardan en el servidor, también protegidas.",
  },
  pendingDialog: {
    title: "Acción pendiente de integración",
    body: () =>
      "Esta acción requiere una integración que todavía no está conectada. En este modo no se ejecutan llamadas reales ni se simulan resultados.",
    registered: "La solicitud quedó registrada en Tareas como bloqueada para que puedas revisarla.",
    notRegistered: "No se ha registrado ninguna tarea ni se ha realizado ningún cargo.",
    viewTasks: "Ver tareas",
  },
  home: {
    title: "Inicio",
    greeting: (ws) => ws || "Estudio",
    quick: "Herramientas rápidas",
    createImage: "Crear imagen",
    createImageDesc: "Prompt, referencias y formato. El modelo actual (Seedream 5.0 Pro) genera 1 imagen por ejecución.",
    createVideo: "Crear vídeo",
    createVideoDesc: "Imagen inicial/final, duración y referencias según modelo.",
    editImage: "Editar imagen",
    editImageDesc: "Instrucciones sobre una imagen existente; nunca sobrescribe el original.",
    upscaler: "Upscaler",
    upscalerDesc: "Mejora de resolución con IA. Se verificará el servicio disponible.",
    newProduction: "Nueva producción",
    newProductionDesc: "Proyecto con storyboard, lienzo y editor conectados.",
    recent: "Proyectos recientes",
    recentEmpty: "Aún no hay proyectos. Crea tu primera producción.",
    tasks: "Tareas",
    tasksEmpty: "No hay tareas registradas.",
    viewAll: "Ver todo",
    connections: "Conexiones",
    imageVideo: "Imágenes y vídeo",
    textAssistant: "Asistente de texto",
    budget: "Presupuesto",
    budgetNoLimit: "Sin límite configurado",
    spent: "Consumo real medido",
    spentNone: "Sin datos — sin llamadas reales",
    budgetSummary: (limit, pct) => `US$ ${limit} / mes · alerta al ${pct}%`,
  },
  onboarding: {
    title: "Configuración inicial",
    subtitle: "Un solo propietario. Se puede reanudar y modificar más tarde en Ajustes.",
    steps: ["Acceso privado", "Workspace", "Conexiones", "Asistente", "Presupuesto", "Primer proyecto"],
    access: {
      title: "Acceso privado",
      body:
        "Veyra es un estudio privado. La autenticación real, el cierre del registro inicial y el almacenamiento seguro llegarán más adelante. Por ahora solo se reserva este paso; no se guarda ninguna contraseña.",
      owner: "Nombre del propietario",
      ownerPh: "Michael",
      note: "No se pedirá contraseña hasta que exista un inicio de sesión seguro.",
      language: "Idioma de la interfaz",
      languageHint: "Cambia los menús, botones y mensajes de Veyra. No traduce tus prompts, guiones ni futuras narraciones.",
    },
    workspace: {
      title: "Workspace",
      name: "Nombre del Workspace",
      namePh: "Estudio Veyra",
      es: "Español",
      en: "English",
      brandNote: "Veyra permanece como marca; el Workspace es tu espacio de trabajo.",
      formatPref: "Formato preferido",
      formatPrefHint: "Se usará como formato por defecto en producciones nuevas. Podrás cambiarlo en cada generación.",
      resolutionPref: "Resolución de imagen predeterminada",
      resolutionPrefHint: "Punto de partida en el generador de imágenes; se puede ajustar en cada generación.",
    },
    connections: {
      title: "Conexiones",
      body:
        "Las conexiones vinculan Veyra con proveedores de generación de imagen, vídeo, texto o audio/voz. Apimart es el primer proveedor disponible, para imagen y vídeo; ElevenLabs aparece preparado para audio/voz como integración pendiente. La clave real se guardará de forma segura y los modelos se verificarán con la documentación oficial más adelante.",
      add: "Añadir conexión de ejemplo",
      explore: "Puedes explorar la interfaz sin crear ninguna conexión. Crear una solo habilita los formularios de generación; la generación real necesita además una conexión verificada y un modelo compatible, algo que esta fase todavía no permite.",
      createdNote: "Conexión creada sin clave. Estado: Sin clave configurada.",
    },
    assistant: {
      title: "Asistente de texto",
      body:
        "El asistente de guiones y prompts necesita una conexión compatible con texto. Ninguna de tus conexiones admite texto todavía. Se podrá configurar cuando exista una conexión de texto verificada.",
      provider: "Conexión de texto",
      providerPh: "Se definirá tras verificar capacidades",
      disabled: "Todavía no disponible.",
    },
    budget: {
      title: "Presupuesto y alertas",
      body: "Límite orientativo de gasto mensual en generación. No se cargan tarifas ni precios; el consumo real se medirá cuando existan llamadas.",
      limit: "Límite mensual (USD)",
      alert: "Alerta al alcanzar (%)",
      noLimit: "Sin límite",
      block: "Bloquear nuevas generaciones al alcanzar el presupuesto",
      blockHint: "Se guarda como preferencia. El bloqueo real de gasto se activará junto con la conexión del proveedor; por ahora no hay cargos que bloquear.",
    },
    first: {
      title: "Primer proyecto",
      body: "Crea tu primera producción o ve a una herramienta rápida.",
      projectName: "Nombre del proyecto",
      projectPh: "Spot producto — verano",
      createAndOpen: "Crear proyecto y abrir",
      goHome: "Ir al Inicio",
    },
    done: "Configuración completada",
    exploreWithout: "Explorar sin terminar →",
    accessComingSoon: "Próximamente: autenticación, sesión y cierre del registro inicial.",
  },
  guestOnboarding: {
    title: "Bienvenida a VEYRA",
    subtitle: "Configura tu espacio personal de trabajo en tres sencillos pasos.",
    steps: ["Tu estudio", "Conectar Apimart", "Controlar tu gasto y empezar"],
    step1: {
      title: "Tu estudio",
      subtitle: "Personaliza cómo te identificas en el estudio y el idioma de tu interfaz.",
      nameLabel: "Tu nombre en el estudio",
      namePlaceholder: "Tu nombre o alias",
      languageLabel: "Idioma de la interfaz",
      languageHint: "Puedes cambiar el idioma en cualquier momento desde Ajustes.",
    },
    step2: {
      title: "Conectar Apimart",
      subtitle: "Configura tu clave personal de API para generar imágenes y vídeos con tus propios créditos.",
      keyLabel: "Clave de API de Apimart",
      keyPlaceholder: "Introduce tu API key de Apimart",
      help: "Tu clave se cifra y almacena de forma segura en tu bóveda personal en el servidor. Nunca se comparte con otros miembros del estudio.",
      saveNotice: "Guardar una clave no significa verificarla. La verificación se realiza al generar.",
      saveBtn: "Guardar clave y continuar",
      skipBtn: "Configurar después",
      exploreNotice: "Puedes explorar la interfaz sin clave. Las restricciones de generación se mantendrán activas hasta que configures una clave.",
      successSaved: "Clave de Apimart guardada y protegida en tu bóveda personal.",
      emptyKeyError: "Introduce una clave válida o pulsa «Configurar después».",
    },
    step3: {
      title: "Controlar tu gasto y empezar",
      subtitle: "Define un límite mensual personal para tus generaciones y empieza a crear.",
      limitLabel: "Límite mensual (USD)",
      limitPlaceholder: "Ej: 50.00",
      limitHint: "Puedes configurarlo después. Para generar necesitarás una clave de Apimart y un límite mensual.",
      projectLabel: "Nombre de tu primera producción",
      projectPlaceholder: "Mi primer proyecto",
      createProjectBtn: "Crear mi primer proyecto",
      exploreBtn: "Explorar VEYRA",
    },
  },
  projects: {
    title: "Proyectos",
    new: "Nueva producción",
    empty: "Sin proyectos",
    emptyBody: "Una producción reúne guion, escenas, referencias, lienzo y versiones.",
    scenesCount: (n) => `${n} ${n === 1 ? "escena" : "escenas"}`,
    assetsCount: (n) => `${n} ${n === 1 ? "activo" : "activos"}`,
    deleteConfirm: "¿Eliminar este proyecto y todas sus escenas, nodos y conexiones?",
    formatLabel: "Formato",
  },
  project: {
    views: { storyboard: "Storyboard", canvas: "Lienzo", editor: "Editor", resources: "Recursos" },
    projectResources: "Recursos del proyecto",
    assistant: "Asistente",
    library: "Biblioteca",
    showAssistant: "Mostrar Creative Director",
    hideAssistant: "Ocultar Creative Director",
    showLibrary: "Mostrar biblioteca",
    hideLibrary: "Ocultar biblioteca",
    notFound: "Proyecto no encontrado",
    notFoundBody: "El proyecto no existe o fue eliminado.",
    backToProjects: "Volver a proyectos",
    selectedScene: "Escena seleccionada",
    noSelection: "Sin selección",
  },
  storyboard: {
    addScene: "Nueva escena",
    createFirstScene: "Crear primera toma",
    empty: "Sin escenas",
    emptyBody: "Crea la primera escena o pide al asistente una propuesta de ejemplo.",
    emptyBodyGuest: "Crea tu primera toma para comenzar a estructurar tu proyecto.",
    sceneN: (n) => `Escena ${n}`,
    moveUp: "Subir",
    moveDown: "Bajar",
    approve: "Aprobar",
    unapprove: "Quitar aprobación",
    toReview: "Marcar para revisar",
    toDraft: "Volver a borrador",
    status: { draft: "Borrador", review: "En revisión", approved: "Aprobada" },
    detail: "Detalle de escena",
    showDetail: "Mostrar detalle de escena",
    hideDetail: "Ocultar detalle de escena",
    title: "Título",
    prompt: "Prompt",
    currentPrompt: "Prompt de la toma",
    promptHelp: "Describe qué debe aparecer y suceder en esta toma. Puedes escribirlo o prepararlo con el Creative Director.",
    selectedMediaOrigin: "Origen del medio seleccionado",
    originPrompt: "Prompt original de generación",
    originPromptNotAvailable: "Prompt de origen no disponible",
    originModel: "Modelo",
    originProvider: "Proveedor",
    promptMismatchNotice: "El prompt actual de la escena es diferente del utilizado para generar este medio",
    promptPh: "Ej.: @elena examina planos antiguos en el escritorio de la biblioteca iluminada por velas",
    notes: "Notas de continuidad",
    notesHelp: "Anota detalles que deben mantenerse entre tomas: vestuario, objetos, posición, iluminación o estado de la acción.",
    notesPh: "Ej.: bolso en el hombro izquierdo; el mando sigue guardado; misma luz de tarde",
    sceneAssets: "Medios de la escena",
    sceneMedia: "Medios de la escena",
    noAssets: "Sin medios asociados todavía.",
    noSceneMedia: "Sin medios asociados todavía.",
    chooseFromLibrary: "Elegir de la biblioteca",
    chooseFromGallery: "Elegir de la galería",
    uploadFromDevice: "Subir desde mi dispositivo",
    scopeThisProject: "Este proyecto",
    scopeAllGallery: "Toda mi galería",
    filterAllMedia: "Todos",
    filterImages: "Imágenes",
    filterVideos: "Vídeos",
    uploadProgress: (pct) => `Subiendo... ${pct}%`,
    uploadError: "No se pudo subir la imagen. Inténtalo de nuevo.",
    retryUpload: "Reintentar subida",
    retryAssign: "Reintentar asignación",
    assignErrorPreserved: "No se pudo asignar a la escena, pero el archivo se conservó en tu galería.",
    fileTooLarge10MB: "La imagen supera el tamaño máximo permitido (10 MB).",
    unsupportedImageFormat: "Formato no compatible. Usa PNG, JPEG o WebP.",
    chooseMediaFromLibrary: "Elegir medio de la biblioteca",
    chooseFromLibraryTitle: (sceneName) => `Elegir medio para ${sceneName}`,
    assignToThisScene: "Asignar a esta escena",
    assignToSceneNamed: (sceneName) => `Asignar a ${sceneName}`,
    assignedToSceneSuccess: (sceneName) => `Medio asignado a ${sceneName}`,
    replaceMediaTitle: (sceneName) => `¿Reemplazar medio activo de ${sceneName}?`,
    replaceMediaBody: "La escena ya tiene un medio asignado. Al asignar este nuevo medio, el actual se conservará en la biblioteca del proyecto.",
    replaceMediaConfirm: "Reemplazar medio",
    directGenerationSoon: "Generación directa próximamente",
    directGenerationHint: "La generación directa desde la escena todavía no está integrada. Puedes abrir la toma en el Editor para trabajar con ella.",
    useThisMedia: "Usar este medio",
    selectedMediaBadge: "Seleccionado",
    generate: "Generar imagen para esta escena",
    openInEditor: "Abrir en editor",
    openInCanvas: "Ver en lienzo",
    deleteConfirm: "¿Eliminar esta escena? Sus nodos y conexiones del lienzo también se eliminarán.",
    trash: "Papelera",
    sceneDeleted: "Escena eliminada",
    undo: "Deshacer",
    restore: "Restaurar",
    restoredSuccess: "Escena restaurada",
    trashTitle: "Papelera del proyecto",
    trashSubtitle: "Las escenas eliminadas de este proyecto se conservan aquí para poder recuperarlas.",
    trashEmpty: "La papelera está vacía",
    trashSyncError: "No se pudo sincronizar la papelera con el servidor.",
    trashSyncRetry: "Reintentar conexión",
    deletedAt: (date) => `Eliminada el ${date}`,
    pickReferences: "Elegir referencias",
    noReferences: "Sin referencias",
    permanentDelete: "Eliminar definitivamente",
    emptyTrash: "Vaciar papelera",
    purgeConfirmTitleSingle: (title) => `¿Eliminar definitivamente «${title}»?`,
    purgeConfirmTitleBatch: (count) => `¿Vaciar la papelera (${count} escenas)?`,
    purgeConfirmWarning: "Esta acción es irreversible. Las escenas afectadas ya no podrán recuperarse.",
    purgeDefaultNotice: "Por defecto solo se eliminarán las escenas de la papelera. Sus imágenes y vídeos se conservarán en la Galería, y sus personajes, objetos y referencias en la biblioteca.",
    deleteFilesCheckbox: "Eliminar también los archivos utilizados únicamente por estas escenas",
    deleteFilesNote: "Solo se retirarán archivos directos sin otro uso. Los personajes, objetos y fichas de referencias nunca se eliminarán.",
    deletableFilesCount: (count) => `${count} archivo(s) exclusivo(s) eliminable(s)`,
    protectedFilesCount: (count) => `${count} archivo(s) protegido(s) por otros usos`,
    spaceFreedEstimate: (space) => `Espacio a liberar: ${space}`,
    spaceUnavailable: "Espacio no disponible",
    calculatingUsage: "Calculando uso de archivos…",
    purging: "Eliminando…",
    purgeSuccessSingle: "Escena eliminada definitivamente",
    purgeSuccessBatch: "Papelera vaciada correctamente",
    purgePartialError: "Se eliminaron las escenas, pero algunos archivos no se pudieron borrar físicamente. Se registró para reintento.",
  },
  canvas: {
    addNode: "Añadir nodo",
    nodeTypes: { text: "Texto", reference: "Referencia", image: "Imagen", video: "Vídeo" },
    empty: "Lienzo vacío",
    emptyBody: "Añade nodos y conéctalos arrastrando desde el puerto de salida al puerto de entrada.",
    hint: "Arrastra nodos para moverlos. Arrastra desde ● (salida) hasta ○ (entrada) para conectar. Clic en una conexión para seleccionarla; Supr para borrar.",
    deleteEdge: "Eliminar conexión",
    deleteNode: "Eliminar nodo",
    run: "Ejecutar nodo",
    runHint: "Un solo nodo por ejecución (v1).",
    invalid: {
      sameNode: "Un nodo no puede conectarse consigo mismo.",
      duplicate: "Esa conexión ya existe.",
      cycle: "La conexión crearía un ciclo de ejecución.",
      type: (a, b) => `No se permite conectar ${a} → ${b}.`,
      videoOut: "Un nodo de vídeo no tiene salidas en v1.",
    },
    linkedScene: "Escena vinculada",
    unlinked: "Sin vincular",
    textPh: "Texto o prompt…",
    pickAsset: "Elegir imagen",
    noAsset: "Sin imagen asignada",
    noVideo: "Sin vídeo generado",
    pickReference: "Elegir referencia",
    zoom: "Zoom",
    fit: "Restablecer vista",
    edges: (n) => `${n} ${n === 1 ? "conexión" : "conexiones"}`,
    nodes: (n) => `${n} ${n === 1 ? "nodo" : "nodos"}`,
  },
  editor: {
    empty: "Sin imagen seleccionada",
    emptyBody: "Selecciona una escena con imagen en el Storyboard o una versión en la biblioteca.",
    instructions: "Instrucciones de edición",
    instructionsPh: "Ej.: cambia el fondo a una pared de hormigón, mantén la iluminación…",
    applyInstructions: "Aplicar instrucciones",
    before: "Antes",
    after: "Después",
    compare: "Comparar",
    history: "Historial de versiones",
    crop: "Recortar",
    rotate: "Rotar 90°",
    cropRatios: { "1:1": "1:1", "16:9": "16:9", "9:16": "9:16", "4:5": "4:5" },
    sendUpscale: "Enviar al Upscaler",
    originalNote: "El original nunca se sobrescribe; cada operación crea una versión nueva.",
    processing: "Procesando…",
    error: "No se pudo procesar la imagen (origen no accesible o formato no soportado).",
    localOp: "Operación local",
    videoNote: "Reproductor de vídeo con controles nativos. Las herramientas de edición y transformación están disponibles para imágenes.",
    sceneVersions: "Versiones de la escena",
    selectedVersion: "Seleccionada",
    inUse: "En uso",
    useInScene: "Usar",
    videoType: "Vídeo",
    imageType: "Imagen",
    untitledVideo: "Vídeo sin título",
    untitledImage: "Imagen sin título",
    originalFile: "Archivo original",
    imageToEdit: "Imagen que vas a editar",
    baseImageChanged: "La imagen base ha cambiado a esta versión. Las instrucciones se aplicarán sobre ella.",
    requestedAssetNotFound: "El recurso solicitado no existe o no pertenece a este proyecto.",
    lastResultTitle: "Último resultado completado",
    generatedFrom: "Generado a partir de",
    viewResult: "Ver resultado en el editor",
  },
  characters: {
    title: "Biblioteca de personajes",
    subtitle: "Personajes, productos, escenarios y texturas con vistas múltiples y referencias reutilizables.",
    new: "Nuevo personaje",
    edit: "Editar personaje",
    openSheet: "Ver ficha",
    kinds: { character: "Personaje", product: "Producto", scenario: "Escenario", texture: "Textura", vehicle: "Vehículo", prop: "Prop / Objeto" },
    empty: "Sin personajes",
    emptyBody: "Crea tu primer personaje para guardar sus rasgos, vestuario base y vistas de referencia.",
    master: "Imagen principal",
    masterBadge: "Principal",
    setAsMaster: "Marcar como principal",
    views: "Vistas",
    viewsCount: (n) => `${n} ${n === 1 ? "vista" : "vistas"}`,
    noMaster: "Sin imagen principal",
    addView: "Añadir vista",
    pickFromLibrary: "Elegir de la biblioteca",
    uploadImage: "Subir imagen",
    uploading: "Subiendo...",
    removeView: "Quitar vista",
    viewTypes: {
      front: "Frontal",
      side: "Perfil",
      back: "Espalda",
      expression: "Expresión",
      other: "Otra",
    },
    identitySection: "Identidad y rasgos físicos",
    identityPlaceholder: "Edad aparente, complexión, rasgos faciales distintivos, color de pelo, ojos...",
    outfitSection: "Vestuario base (separado de la identidad)",
    outfitPlaceholder: "Ropa habitual, colores característicos, calzado o accesorios canónicos...",
    outfitHint: "El vestuario base se documenta de forma separada para mantener la identidad física al cambiar de ropa en escenas.",
    handleHint: "Identificador único con @ para menciones en prompts (ej. @sarah_chen).",
    handleCollision: (h) => `El handle @${h} ya está en uso en este ámbito. Elige otro.`,
    handleRequired: "El @handle es obligatorio.",
    nameRequired: "El nombre es obligatorio.",
    projectScope: "Proyecto",
    allProjects: "Todos los proyectos",
    searchPlaceholder: "Buscar por nombre o @handle...",
    deleteConfirm: "¿Eliminar este personaje? Se quitará de las escenas vinculadas, pero las imágenes se conservarán en la galería.",
    discardConfirmTitle: "¿Descartar cambios no guardados?",
    discardConfirmBody: "Has realizado modificaciones que no se han guardado. Si sales ahora, se perderán los cambios.",
    continueEditing: "Continuar editando",
    discardChanges: "Descartar cambios",
    referenceNote: "La ficha puede almacenar múltiples vistas. En cada generación se envían un máximo de 2 referencias (o menos según las capacidades del modelo).",
    mentionNote: "La mención @handle documenta la presencia del personaje en el prompt. No sustituye la selección de referencias.",
    requestView: "Solicitar nueva vista",
    usedIn: (n) => `Usado en ${n} ${n === 1 ? "escena" : "escenas"}`,
    prefilledFromGallery: "Imagen maestra preasignada desde la Galería.",
    useAsProjectCover: "Usar como portada del proyecto",
    useAsProjectCoverNamed: (name) => `Usar como portada de: ${name}`,
    currentProjectCover: "Portada actual del proyecto",
    currentProjectCoverNamed: (name) => `Portada actual de ${name}`,
    coverUpdated: (name) => `Imagen establecida como portada de "${name}".`,
    saveBeforeCover: "Guarda los cambios de la ficha antes de asignar la portada al proyecto.",
    assignProjectBeforeCover: "Asigna un proyecto al personaje para fijar su portada.",
    alreadyProjectCover: (name) => `Esta imagen ya es la portada de "${name}".`,
    foreignAssetCoverError: "El activo no pertenece ni está autorizado para este proyecto.",
    analyzeSectionTitle: "Autocompletar ficha desde imagen",
    analyzeImageBtn: "Analizar imagen y completar ficha",
    analyzingImage: "Analizando imagen...",
    noVisionModelNotice: "Para autocompletar la ficha mediante análisis de imagen, se requiere una conexión con capacidad de visión (ModelCapability.VISION). Actualmente no hay modelos con visión configurados en Ajustes > Conexiones LLM.",
    modelCostEstimate: (model, cost) => `Modelo: ${model} · Coste estimado: US$${cost}`,
    proposalTitle: "Propuesta de análisis visual",
    proposalSubtitle: "Rasgos observables directamente en la imagen. Revisa y acepta cada bloque:",
    applyToIdentity: "Aplicar a Identidad",
    applyToOutfit: "Aplicar a Vestuario",
    discardProposal: "Descartar propuesta",
    appliedToIdentity: "Identidad actualizada con la propuesta visual.",
    appliedToOutfit: "Vestuario actualizado con la propuesta visual.",
    imageChangedDuringAnalysis: "La imagen analizada cambió durante el proceso; la propuesta anterior fue descartada.",
    visibleTraitsNotice: "Describe únicamente rasgos visibles observados en la imagen.",
    selectViewsPrompt: "Elige las vistas guardadas que deseas usar como referencia visual para la generación.",
    noViewsTitle: "Sin vistas guardadas",
    noViewsDesc: "Este personaje no tiene vistas guardadas en la biblioteca. Puedes añadir vistas desde la ficha del personaje o usar referencias manuales.",
    noViewAttachedNote: "La mención @handle se conservará en el texto, pero no se adjuntará ninguna referencia vacía.",
    savedViewsCount: (n) => `${n} ${n === 1 ? "vista disponible" : "vistas disponibles"}`,
    maxReferencesAllowed: (n) => `Máximo total de ${n} referencias`,
    linkViewsButton: "Seleccionar vistas",
    linkViewsButtonCount: (n) => `Vincular ${n} vista${n > 1 ? "s" : ""}`,
  },
  gallery: {
    title: "Galería",
    subtitle: "Todas las versiones de imagen y vídeo del workspace.",
    empty: "Galería vacía",
    emptyBody: "Aquí aparecerán los resultados de generación y las versiones editadas.",
    filters: { all: "Todo", image: "Imágenes", video: "Vídeos" },
    projectFilterLabel: "Proyecto",
    projectFilterAllHint: "Mostrando activos de todos los proyectos, incluidos los sin proyecto.",
    openEditor: "Abrir en editor",
    openEditorNoProject: "Disponible solo para activos de un proyecto.",
    openEditorVideo: "El editor solo admite imágenes.",
    download: "Descargar",
    useAsReference: "Usar como referencia",
    upscale: "Upscaler",
    upscaleVideoDisabled: "Upscaler de vídeo no disponible en esta fase.",
    source: { demo: "Demo", upload: "Subida", generation: "Generación", edit: "Edición local" },
    sourceLabel: "Origen",
    sceneLabel: "Escena",
    technicalInfo: "Información técnica",
    originalFile: "Archivo original",
    assetId: "ID del recurso",
    dimensions: "Dimensiones",
    realDimensions: "Dimensiones reales",
    aspectRatio: "Relación aspecto",
    notAvailable: "No disponible",
    sourceUpload: "Subida",
    sourceGeneration: "Generación",
    sourceUnknown: "No especificado",
    uploadedAssetTitle: "Imagen subida",
    uploadedAssetNotice: "Este recurso fue subido manualmente y no procede de una tarea de generación.",
    generationJobNotFoundTitle: "Generación (tarea no localizable)",
    generationJobNotFoundNotice: "Este recurso procede de una generación, pero no se encontró un trabajo productor asociado en el historial local.",
    unknownSourceTitle: "Origen no especificado",
    unknownSourceNotice: "No se dispone de información sobre el origen de este recurso.",
    selectMode: "Seleccionar",
    selectAll: "Seleccionar todas",
    deselect: "Deseleccionar",
    deleteSelected: (n) => `Eliminar seleccionadas (${n})`,
    deleteSelectedDate: (n) => `Eliminar seleccionadas de esta fecha (${n})`,
    dateSelectedCount: (n) => `(${n} seleccionada${n !== 1 ? "s" : ""})`,
    totalSelectedCount: (n) => `${n} seleccionada${n !== 1 ? "s" : ""}`,
    floatingActionsTitle: "Acciones de selección",
  },
  tasks: {
    title: "Tareas",
    subtitle: "Historial de generaciones, ediciones y upscale del workspace.",
    empty: "Sin tareas",
    emptyBody: "Las solicitudes de generación, edición y upscale aparecerán aquí con su estado.",
    status: {
      blocked: "Bloqueada",
      pending: "Pendiente",
      running: "En curso",
      done: "Completada",
      failed: "Fallida",
      uncertain: "Incierta",
      cancelled: "Cancelada",
    },
    kinds: { image: "Imagen", video: "Vídeo", edit: "Edición", upscale: "Upscale", assistant: "Asistente", canvas: "Nodo del lienzo" },
    blockedReason: "Proveedor no conectado. No se ha enviado ni cobrado nada.",
    blockedReasonNoKey: "Conexión sin clave configurada. No se ha enviado ni cobrado nada.",
    uncertainReason: "Estado de envío incierto: el proveedor podría haber recibido la petición. No se reenvió para evitar un segundo cargo posible. Comprueba el panel del proveedor si tienes acceso.",
    requestedSize: "Tamaño solicitado",
    simTag: "Simulada",
    model: "Modelo",
    modelUnknown: "Sin verificar",
    cost: "Coste",
    costUnknown: "Sin datos",
    costEstimated: (v) => `Estimado US$ ${v}`,
    costConfirmed: (v) => `Confirmado US$ ${v}`,
    countHint: "Hay tareas bloqueadas: la conexión no tiene clave configurada todavía.",
    clear: "Eliminar tareas bloqueadas",
    clearConfirm: (n) => `Se eliminarán permanentemente ${n} tarea${n !== 1 ? "s" : ""} bloqueada${n !== 1 ? "s" : ""}. Esta acción no se puede deshacer.`,
    demoTag: "Tarea de demostración",
  },
  tools: {
    navImage: "Imagen",
    navEdit: "Editar imagen",
    navVideo: "Vídeo",
    navUpscale: "Upscaler",
    back: "Volver",
    guestKeyMissing: "Configura tu clave de Apimart para generar",
    guestBudgetMissing: "Establece un límite mensual antes de generar",
    guestBudgetInsufficient: "Presupuesto insuficiente para esta generación",
    catalogLoadError: "Error al consultar las conexiones del servidor. No se pudo comprobar el estado de tu clave.",
    catalogErrorRetry: "Error al consultar conexiones. Pulsa reintentar.",
    loadingConnections: "Cargando conexiones...",
    connectionsError: "Error al consultar conexiones (pulsa reintentar)",
    budgetInsufficient: (avail, cost) => `Presupuesto insuficiente: el disponible ($${avail}) no cubre el coste estimado ($${cost}).`,
    image: { title: "Crear imagen", cta: "Generar imagen" },
    video: { title: "Crear vídeo", cta: "Generar vídeo" },
    edit: { title: "Editar imagen", cta: "Aplicar edición" },
    upscale: { title: "Upscaler", cta: "Mejorar resolución" },
    promptPh: "Describe lo que quieres crear…",
    references: "Referencias (@handles)",
    referencesEmpty: "Añade miniaturas de referencia desde Characters o la galería.",
    format: "Formato",
    formatMore: "Formatos extendidos",
    formatAuto: "Auto",
    quantity: "Cantidad",
    resolution: "Resolución",
    resolutionIncompatible: "No disponible en este modelo",
    model: "Modelo",
    connection: "Conexión",
    connectionPick: "Elegir conexión",
    modelNote: "",
    modelChangedWarning: "Al cambiar de modelo, revisa formato y resolución: pueden dejar de ser compatibles. Veyra nunca los cambia en silencio.",
    modelChangedReset: "Modelo cambiado: formato y resolución ajustados automáticamente a valores compatibles.",
    incompatibleSelection: "La combinación de formato/resolución elegida no es compatible con este modelo. Ajústala antes de generar.",
    costEstimateTitle: "Coste estimado",
    costEstimated: (v) => `Estimado: ${v}`,
    costAvailableEstimated: (a, c) => `Quedan ${a} · esta generación ${c}`,
    costBudgetLimit: "Tope mensual configurado",
    costBudgetNone: "Sin tope configurado",
    costBudgetAvailable: "Presupuesto disponible",
    costUnverified: "no verificado",
    costUnverifiedTitle: "Este importe no está confirmado por fuente primaria verificada",
    costExtraRef: (v) => `+ ${v} por referencia adicional (desde la 2.ª)`,
    costDemoNote: "Precio estimado, no verificado. Fuente interna; pendiente de confirmación en documentación oficial de Apimart.",
    phase5Notice: "No disponible en esta fase (Fase 5).",
    phase5Body: "El upscaler de vídeo no está disponible en esta fase.",
    upscaleModel: "Modelo de upscale",
    upscaleScale: "Factor de escala",
    upscaleScaleOption: (n) => `${n}× (resolución ${n === 2 ? "doble" : "cuádruple"})`,
    upscaleOriginalLabel: "Imagen fuente",
    upscaleNoSource: "Selecciona imagen fuente de la galería",
    upscalePickSource: "Cambiar imagen fuente",
    upscaleReserveNotice: (usd) => `Precio no publicado · Reserva: $${usd} (conservadora). El coste real se reconciliará al completar.`,
    upscaleNoPriceBlock: "Precio no disponible — la reserva protege tu presupuesto. El coste real se reconciliará al terminar.",
    upscaleSubmit: "Enviar al upscaler",
    upscaleSubmitting: "Enviando…",
    upscaleSuccessTitle: "Upscale enviado",
    upscaleSuccessBody: "Tu imagen está siendo escalada. Aparecerá en Galería cuando esté lista.",
    upscalePreservedNote: "El original se conserva. El upscale crea un nuevo asset.",
    simulateLabel: "Simular finalización (modo prueba, sin clave)",
    simulateSuccess: "Simulación completada — activo disponible en Galería",
    refsCap: "Máx. 2 referencias por generación.",
    refsLimitModalTitle: "Límite de referencias alcanzado",
    refsLimitModalSubtitle: "El modelo actual permite un máximo de referencias por generación. Selecciona cuáles deseas conservar:",
    selectRefsToKeep: "Elige las referencias a conservar:",
    manualRef: "Manual",
    candidateRef: "Nueva",
    overLimitWarning: (n) => `Has seleccionado más de ${n} referencias. Desmarca alguna para continuar.`,
    confirmKeepRefs: (n) => `Conservar ${n} referencia${n > 1 ? "s" : ""}`,
    changeView: "Cambiar",
    modelRefsIncompatible: (m) => `El modelo seleccionado (${m}) no admite referencias de imagen. Retira las referencias o selecciona un modelo compatible.`,
    videoRefsIncompatible: "La modalidad de vídeo no admite imágenes de referencia adicionales. Retira las referencias o utiliza Start Frame / End Frame.",
    editOriginalPreserved: "El original se conserva. La edición genera un activo nuevo.",
    whatToChange: "¿Qué quieres cambiar?",
    additionalReferences: "Referencias adicionales",
    additionalReferencesNote: "Añade imágenes de referencia para guiar personajes, estilo o elementos.",
    originalPreservedBrief: "El original se conserva",
    originalPreservedFull: "El original se conserva; la edición crea un activo nuevo.",
    uploadAnother: "Subir otra imagen",
    moreActions: "Más acciones",
    project: "Guardar en proyecto",
    sourceImage: "Imagen de origen",
    pickSource: "Elegir de la galería",
    replaceSource: "Reemplazar",
    removeSource: "Quitar",
    expand: "Ampliar",
    clickToExpand: "Pulsar para ampliar",
    noSourceSelected: "No hay imagen de origen seleccionada",
    selectSourceHelp: "Elige una imagen de la galería o sube una desde tu equipo para comenzar la edición.",
    uploadTest: "Subir imagen",
    uploadTooLarge: "La imagen supera el tamaño máximo permitido (10 MB).",
    uploadUnsupported: "Formato no admitido. Usa JPG, PNG o WebP.",
    uploadFailed: "No se pudo subir la imagen. Inténtalo de nuevo.",
    uploadEmpty: "El archivo está vacío.",
    uploadTestNote: "Las imágenes se suben a tu servidor protegido (máx. 10 MB, JPG/PNG/WebP). Las ediciones crean versiones nuevas sin sobrescribir el original.",
    duration: "Duración",
    durationNote: "Segundos. Depende del modelo elegido.",
    startFrame: "Imagen inicial",
    endFrame: "Imagen final",
    videoMode: "Modo",
    videoModes: { text_to_video: "Texto a vídeo", image_to_video: "Imagen inicial a vídeo", first_last_frame: "Fotograma inicial/final", motion_control: "Control de movimiento (Motion Control)" },
    motionVideo: "Vídeo de movimiento",
    frameFormatMismatch: "El formato de la imagen elegida no coincide con el formato de salida. Ajusta el formato o elige otra imagen; Veyra no recorta en silencio.",
    cheapTest: "Prueba económica",
    cheapTestApply: "Aplicar ajuste económico",
    cheapTestApplied: (res, dur) => `Ajuste económico aplicado: ${res} · ${dur}s · 1 salida (precio demo, sin tarifas verificadas).`,
    cheapTestNote: "Usa la combinación compatible de menor coste dentro del modelo elegido. No cambia de modelo ni genera automáticamente.",
    nativeNote: "Generación nativa. Una ampliación de resolución posterior es una acción distinta (Upscaler); no se implementa un upscaler de vídeo en esta revisión.",
    factor: "Factor",
    factorNote: "Se verificará si el proveedor conectado ofrece upscaling real; escalar por interpolación no equivale a mejora IA.",
  },
  settings: {
    title: "Ajustes",
    sections: { profile: "Mi perfil", workspace: "Workspace", connections: "Conexiones", budget: "Presupuesto", data: "Datos", about: "Acerca de" },
    workspaceName: "Nombre del Workspace",
    ownerName: "Propietario",
    language: "Idioma",
    formatPref: "Formato preferido",
    resolutionPref: "Resolución predeterminada",
    connectionsBody: "Las claves reales se guardarán de forma segura más adelante. Por ahora no hay campos de clave habilitados; puedes preparar el nombre y proveedor de cada conexión.",
    connectionsEmpty: "Sin conexiones todavía.",
    connectionsEmptyBody: "Añade una conexión para empezar a configurar el generador. Habilitar la generación real requerirá además que esa conexión quede verificada con un modelo compatible; en esta fase eso no es posible todavía.",
    addConnection: "Añadir conexión",
    connectionName: "Nombre de la conexión",
    connectionNamePh: "Apimart — producción",
    connectionProvider: "Proveedor",
    connectionProviderNote: "Apimart es el primer proveedor disponible, para imagen y vídeo. ElevenLabs está preparado para audio/voz como integración pendiente; todavía no admite crear conexiones reales ni de demostración.",
    providerPendingNote: "Este proveedor está marcado como integración pendiente: todavía no se pueden crear conexiones, ni reales ni de demostración.",
    deleteConnection: "Eliminar conexión",
    deleteConnectionConfirm: "¿Eliminar esta conexión? Las tareas que la referencian quedarán sin conexión asignada.",
    ownerRoleLabel: "Propietario",
    guestRoleLabel: "Invitado",
    budgetLimit: "Límite mensual (USD)",
    budgetAlert: "Alerta (%)",
    budgetBlock: "Bloquear nuevas generaciones al alcanzar el presupuesto",
    budgetBlockToggleLabel: "Activar",
    budgetBlockHint: "Preferencia guardada para cuando exista el proveedor conectado. No bloquea nada operativo todavía.",
    budgetBreakdownTitle: "Consumo previsto por categoría",
    budgetBreakdown: { image: "Imágenes", video: "Vídeo", assistant: "Asistente", audio: "Audio/voz" },
    runningTasksLabel: "Tareas en curso",
    resetDemo: "Restaurar datos de demostración",
    resetDemoBody: "Sustituye el estado actual por el fixture demo. Se perderán los cambios locales.",
    clearAll: "Borrar todo",
    clearAllBody: "Vacía el workspace local por completo (incluida la configuración inicial).",
    confirmReset: (n) => `¿Restaurar los datos de demostración? Se perderán ${n} elemento${n !== 1 ? "s" : ""} de trabajo real. Esta acción no se puede deshacer.`,
    confirmClear: (n) => `¿Borrar todos los datos? Se eliminarán ${n} elemento${n !== 1 ? "s" : ""} (proyectos, escenas, activos, tareas). Esta acción no se puede deshacer.`,
    sessionTitle: "Sesión",
    logoutHint: "Cierra tu sesión en este dispositivo. Deberás volver a iniciar sesión con tu correo y contraseña.",
    passwordLabel: "Contraseña",
    importLocal: "Importar datos de este navegador",
    importLocalBody: "Encontramos un workspace guardado en este navegador (de antes de activar la base de datos). Impórtalo para reemplazar tus datos actuales, o ignóralo si no lo necesitas.",
    importLocalButton: "Importar ahora",
    confirmImport: "¿Reemplazar tus datos actuales por el workspace guardado en este navegador? Esta acción no se puede deshacer.",
    aboutBody: "Veyra v0.2 — acceso privado y base de datos real activados. Sin proveedores de generación conectados todavía.",
    storage: "Almacenamiento",
    storageBody: "Base de datos protegida por tu sesión; las imágenes subidas se guardan en el servidor.",
    logoNote: "El símbolo V es una reconstrucción vectorial provisional del logo aprobado; pendiente de activo oficial limpio.",
    onboardingStepsTitle: "Estado de la configuración inicial",
  },
  assistant: {
    title: "VEYRA Creative Director",
    subtitle: "Tu asistente de producción audiovisual",
    statusPending: "Conexión de IA pendiente de configuración",
    statusPendingDesc: "La conexión en vivo con OpenAI y Claude se activará en el Checkpoint 15B.",
    providers: {
      openai: "OpenAI",
      claude: "Claude",
      openaiModel: "GPT-4o (Preconfigurado)",
      claudeModel: "Claude 3.5 Sonnet (Preconfigurado)",
    },
    modes: {
      normal: "Vista lateral (redimensionable)",
      expanded: "Expandir (50%)",
      restore: "Restaurar tamaño",
      fullscreen: "Pantalla completa",
      exitFullscreen: "Salir de pantalla completa",
      collapse: "Contraer asistente",
      dockTab: "Creative Director",
    },
    welcomeTitle: "Bienvenido al Creative Director",
    welcomeBody: "Tu copiloto de producción audiovisual. Diseña guiones, optimiza prompts cinematográficos, estructura storyboards y cuida la continuidad estética de tus escenas.",
    quickActionsTitle: "Acciones rápidas",
    quickActions: {
      script: {
        label: "Crear guion",
        prompt: "Estructura un guion audiovisual para este proyecto, detallando escenas, plano sugerido, ambientación y locución/diálogos.",
      },
      prompt: {
        label: "Preparar prompt",
        prompt: "Redacta un prompt cinematográfico de alta calidad para la escena seleccionada, definiendo sujeto, iluminación, óptica de cámara, paleta de colores y estilo.",
      },
      improve: {
        label: "Mejorar escena",
        prompt: "Analiza la escena actual y propón mejoras visuales y narrativas para elevar su impacto cinematográfico y coherencia estética.",
      },
      storyboard: {
        label: "Crear storyboard",
        prompt: "Estructura el storyboard cinematográfico para este proyecto a partir del guion activo, definiendo planos, acciones, referencias y reutilizando tomas existentes cuando aplique.",
      },
      continuity: {
        label: "Revisar continuidad",
        prompt: "Revisa la continuidad visual entre escenas: consistencia de personajes, iluminación, dirección de arte y coherencia temporal.",
      },
      plan: {
        label: "Planificar producción",
        prompt: "Genera un plan de producción para este proyecto, organizando escenas prioritarias, necesidades de referencias visuales y orden de generación.",
      },
    },
    scriptSelectorTitle: "Selección de Guion",
    selectActiveScriptHint: "Elige o confirma el guion activo para estructurar el Storyboard",
    readScript: "Leer guion",
    changeScript: "Cambiar guion",
    activeScriptLabel: "Guion activo",
    noActiveScript: "Sin guion activo en el proyecto",

    inputPh: "Escribe una idea, guion o consulta para tu producción… (Shift+Enter para nueva línea)",
    scriptInputPh: "¿Qué quieres contar? Puedes describir tu idea o pedirme que te proponga algunas",
    scriptDraftBanner: "Crear guion",
    scriptDraftInstruction: "¿Qué quieres contar? Puedes describir tu idea o pedirme que te proponga algunas",
    scriptCancel: "Cancelar",
    send: "Enviar",
    newLineHint: "Shift + Enter para salto de línea",
    notConnectedReply: "Conexión de IA pendiente de configuración. Tu instrucción ha sido guardada en el hilo del proyecto y se enviará al modelo una vez activada la conexión en el Checkpoint 15B.",
    demoNote: "Las propuestas están marcadas como Demo: son plantillas locales, no respuestas de un modelo. El asistente se conectará a un modelo real más adelante.",
    proposeScenes: "Proponer 3 escenas (plantilla demo)",
    proposalTitle: "Propuesta de escenas",
    templateTitle: (n) => `Propuesta de escenas · plantilla ${n}`,
    templateScenes: [
      { title: "Establecimiento", prompt: "Plano general del escenario, luz natural, composición con regla de tercios." },
      { title: "Acción principal", prompt: "Plano medio del personaje interactuando con el producto, foco en manos y producto." },
      { title: "Cierre", prompt: "Primer plano del producto con espacio negativo para claim." },
    ],
    reviewHint: "Revisa cada propuesta antes de aplicarla: nada se añade al Storyboard sin tu confirmación.",
    applyAll: "Aplicar todas",
    applyOne: "Aplicar",
    appliedTag: "Aplicada",
    reviewProposal: "Revisar propuesta",
    closeReview: "Cerrar revisión",
    confirmAndApplyAll: "Confirmar e incorporar todas",
    confirmSceneAdd: "¿Añadir toma al proyecto?",
    confirmAllScenesPrompt: (n) => `¿Incorporar ${n} escenas al Storyboard?`,
    dismissProposal: "Descartar propuesta",
    dismissedTag: "Descartada",
    reactivateProposal: "Reactivar propuesta",
    partiallyAppliedTag: (applied, total) => `${applied}/${total} aplicadas`,
    showDetails: "Ver detalle",
    hideDetails: "Ocultar detalle",
    estimatedDuration: "Duración estimada",
    proposalScenesSummary: (count, seconds) => `${count} tomas · ~${seconds}s total`,
    referencedAssets: "Referencias vinculadas",
    continuityInspectionTitle: "Alertas de Continuidad",
    continuityInspecting: "Analizando continuidad y raccord cinematográfico...",
    continuityClean: "No se detectaron contradicciones en la información revisada",
    continuityCleanDesc: "El análisis revisa texto y metadatos; esto no garantiza continuidad visual de los fotogramas generados.",
    continuityError: "Error al inspeccionar la continuidad del proyecto.",
    continuityRetry: "Reintentar inspección",
    continuityAlertsCount: (n) => `${n} alerta${n === 1 ? "" : "s"} de continuidad`,
    continuityDismiss: "Ocultar alertas",
    openScene: "Abrir toma en Storyboard",
    openInStoryboard: "Abrir toma en Storyboard",
    sceneNotFoundInProject: "La toma seleccionada ya no existe en este proyecto.",
    consultiveNotice: "Supervisión consultiva: no modifica escenas automáticamente",
    missingCameraNotice: "Parámetros de cámara no especificados en el prompt. Permanece desconocida (no se asume fija ni estática).",
    unstructuredCameraNotice: "Sin parámetros estructurados de cámara; el prompt contiene indicaciones.",
    empty: "Sin mensajes todavía. Selecciona una acción rápida o escribe una solicitud para tu producción.",
    connectionLabel: "Conexión de texto",
    connectionNone: "Ninguna de tus conexiones admite texto todavía.",
    connectionConfigure: "Configurar conexión de texto",
    connectionHint: "Elige una conexión compatible con texto si existe alguna. No se da por hecha ninguna capacidad del proveedor hasta que esté verificada.",
    workingOnScene: (title) => `Trabajando sobre: ${title}`,
    selectSceneForPrompt: "Selecciona una toma del Storyboard para preparar su prompt",
    selectSceneForImprove: "Selecciona una toma del Storyboard para mejorar su escena",
    draftSceneMismatchTitle: "La toma seleccionada ha cambiado.",
    draftSceneMismatchDesc: (title) => `El borrador actual está vinculado a «${title}». Para evitar enviar datos de otra toma, actualiza el borrador antes de enviar.`,
    updateDraft: "Actualizar borrador",
    unlinkDraft: "Desvincular",
    improveInputPh: "¿Qué deseas cambiar o mejorar en esta toma? (ej. Más entorno, conservar estilo…)",
    requestFix: "Solicitar corrección",
    requestFixPickScene: "¿En qué toma deseas solicitar la corrección?",
    requestFixForScene: (scTitle) => `Corregir en ${scTitle}`,
    continuityDraftNotice: (sceneTitle) => `Trabajando sobre: ${sceneTitle} · Corrección de continuidad`,
  },
  library: {
    scenes: "Escenas",
    references: "Referencias del workspace",
    versions: "Versiones",
    useAsReference: "Usar en escena seleccionada",
    removeReference: "Quitar de la escena",
    openEditor: "Abrir en editor",
    assignToScene: "Asignar a esta escena",
    assignToSceneNamed: (sceneName) => `Asignar a ${sceneName}`,
    activeInScene: "Activo en escena",
    empty: "Nada que mostrar",
  },
  formats: { "1:1": "Cuadrado 1:1", "16:9": "Horizontal 16:9", "9:16": "Vertical 9:16", "4:5": "Retrato 4:5", "3:2": "Foto 3:2" },
  ratioLabels: {
    "auto": "Auto",
    "1:1": "1:1 — Cuadrado",
    "16:9": "16:9 — Horizontal",
    "9:16": "9:16 — Vertical",
    "4:3": "4:3 — Pantalla",
    "3:4": "3:4 — Retrato",
    "3:2": "3:2 — Foto",
    "2:3": "2:3 — Retrato",
    "2:1": "2:1 — Panorámico",
    "1:2": "1:2 — Vertical",
    "21:9": "21:9 — Ultrawide",
    "4:5": "4:5 — Retrato",
    "5:4": "5:4 — Cuadrado+",
    "1:4": "1:4 — Muy vertical",
    "4:1": "4:1 — Muy horizontal",
    "1:8": "1:8 — Extremo vertical",
    "8:1": "8:1 — Extremo horizontal",
  },
  errors: {
    notFound: "Página no encontrada",
    notFoundBody: "La ruta no existe en Veyra.",
    goHome: "Ir al Inicio",
    boundary: "Algo salió mal al renderizar esta vista.",
  },
  auth: {
    setupTitle: "Configura tu acceso privado",
    setupSubtitle: "Este formulario solo funciona una vez. En cuanto crees tu cuenta, el registro queda cerrado para siempre: nadie más podrá apropiarse de este Workspace.",
    setupToken: "Código de instalación",
    setupTokenHint: "El valor de OWNER_SETUP_TOKEN en backend/.env de tu despliegue.",
    reclaimTitle: "Recuperar acceso del propietario",
    reclaimSubtitle: "Ya existe un propietario en este Workspace. Introduce el código de instalación (OWNER_SETUP_TOKEN en backend/.env) para establecer tu correo y contraseña definitivos. Tus proyectos, escenas, archivos y conexiones no se ven afectados.",
    reclaimButton: "Guardar mis credenciales",
    reclaiming: "Guardando...",
    reclaimLink: "¿Eres el propietario y necesitas establecer tu acceso?",
    no_owner_yet: "Todavía no existe un propietario. Usa el formulario de configuración inicial.",
    name: "Tu nombre",
    namePh: "Michael De La Rosa",
    email: "Correo electrónico",
    emailPh: "tu@correo.com",
    password: "Contraseña",
    showPassword: "Mostrar contraseña",
    hidePassword: "Ocultar contraseña",
    passwordHint: "Mínimo 8 caracteres.",
    confirmPassword: "Confirmar contraseña",
    passwordMismatch: "Las contraseñas no coinciden.",
    createAccount: "Crear mi acceso",
    creating: "Creando...",
    loginTitle: "Acceso privado",
    loginSubtitle: "Inicia sesión para continuar con tu Workspace.",
    loginButton: "Iniciar sesión",
    loggingIn: "Entrando...",
    invalid_credentials: "Correo o contraseña incorrectos.",
    account_locked: "Demasiados intentos. Inténtalo de nuevo en unos minutos.",
    setup_already_complete: "La configuración inicial ya se completó. Inicia sesión.",
    invalid_setup_token: "Código de instalación incorrecto.",
    generic: "Ocurrió un error. Inténtalo de nuevo.",
    reclaim_already_used: "El acceso ya fue reclamado. Para cambiar tu contraseña, ve a Ajustes > Mi perfil.",
    wrong_current_password: "La contraseña actual es incorrecta.",
    changePasswordTitle: "Cambiar contraseña",
    currentPassword: "Contraseña actual",
    newPassword: "Nueva contraseña",
    newPasswordHint: "Mínimo 12 caracteres.",
    newPasswordTooShort: "La nueva contraseña debe tener al menos 12 caracteres.",
    changePasswordMismatch: "Las contraseñas nuevas no coinciden.",
    changePasswordSave: "Actualizar contraseña",
    changePasswordSaving: "Actualizando...",
    changePasswordSuccess: "Contraseña actualizada. Sigues dentro con tu nueva clave.",
    logout: "Cerrar sesión",
    loggingOut: "Cerrando sesión...",
    forgotPassword: "¿Olvidaste tu contraseña?",
    recoveryTitle: "Recuperar contraseña",
    recoverySubtitle: "Este estudio no envía correos. El código de recuperación debe generarse mediante acceso administrativo al servidor.",
    recoveryAdminCmd: "Ejecuta en el servidor:",
    recoveryAdminNote: "Compatible con Emergent preview y con tu servidor Hetzner. El código expira en 15 minutos y solo puede usarse una vez.",
    recoveryToken: "Código de recuperación",
    recoveryTokenPh: "Pega aquí el código generado",
    recoveryNewPassword: "Nueva contraseña",
    recoveryConfirmPassword: "Confirmar contraseña",
    recoveryButton: "Restablecer contraseña",
    recoveryBusy: "Verificando...",
    recoverySuccess: "Contraseña restablecida. Ya puedes iniciar sesión.",
    recoveryBackToLogin: "Volver al inicio de sesión",
    invalid_recovery_token: "Código incorrecto o no válido.",
    recovery_token_expired: "El código ha vencido. Genera uno nuevo en el servidor.",
    recovery_token_used: "Este código ya fue usado.",
    recovery_token_exhausted: "Se han agotado los intentos. Genera un nuevo código en el servidor.",
  },
  admin: {
    title: "Panel Administrativo",
    subtitle: "Infraestructura de IA, conexiones, modelos, costes y gobernanza.",
    ownerBadge: "Exclusivo del Propietario",
    unauthorizedTitle: "Acceso restringido",
    unauthorizedBody: "El Panel Administrativo está reservado exclusivamente para el Propietario del estudio.",
    returnHome: "Volver al inicio",
    tabs: {
      overview: "Resumen",
      users: "Miembros e invitaciones",
      connections: "APIs y conexiones",
      models: "Modelos",
      lab: "Laboratorio IA",
      budget: "Costes y presupuestos",
      logs: "Registros",
    },
    sections: {
      overview: {
        title: "Resumen de infraestructura",
        desc: "Arquitectura centralizada con separación estricta entre el Creative Director y la generación audiovisual.",
        sessionTitle: "Sesión administrativa activa",
        sessionDesc: "Autenticado con credenciales oficiales del Propietario.",
        domainsTitle: "Dominios de IA configurados",
        cdDomainTitle: "Creative Director IA",
        cdDomainDesc: "Razonamiento cinematográfico, comprensión de escena, prompts y evaluación de continuidad. Conexiones independientes de LLM.",
        genDomainTitle: "Generación Audiovisual",
        genDomainDesc: "Síntesis de imagen y vídeo, referencias y reconciliación de costes. Motor de ejecución desacoplado con autorización humana obligatoria.",
      },
      connections: {
        title: "APIs y conexiones",
        desc: "Gestión segura de credenciales por dominio de IA.",
        pendingNotice: "Gestor de conexiones en fase de activación (Etapa 2 para Creative Director, Etapa 4 para generación). Las credenciales se almacenarán cifradas en el backend con clave obligatoria independiente y protección anti-SSRF.",
        cdTab: "Creative Director (LLMs)",
        genTab: "Generación Audiovisual",
        cdNotice: "Conexiones dedicadas para modelos de razonamiento (DeepSeek, Qwen/Alibaba, MiniMax y APIs personalizadas). Sin acceso a claves de generación.",
        genNotice: "Conexiones de síntesis de imagen y vídeo. APIMart se mantiene operativo como proveedor actual sin alteraciones.",
        statuses: {
          not_configured: "Sin credenciales",
          configured: "Clave cifrada en bóveda",
          credentials_verified: "Credenciales verificadas",
          inference_verified: "Inferencia verificada",
          error: "Error de conexión",
        },
      },
      models: {
        title: "Catálogo de modelos",
        desc: "Asignación de modelos predeterminados y consulta de capacidades contractuales.",
        pendingNotice: "Módulo en fase de activación. Permitirá fijar los modelos por defecto para guion, imagen y vídeo sin alterar las capacidades verificadas existentes.",
      },
      lab: {
        title: "Laboratorio IA (Creative Director)",
        desc: "Comparación de modelos de razonamiento cinematográfico con benchmarks idénticos.",
        pendingNotice: "Módulo en fase de activación (Etapa 3). Evaluará latencia, tokens y comprensión espacial (benchmark caso Corolla) sin ejecutar generaciones facturables de vídeo.",
      },
      budget: {
        title: "Costes y presupuestos",
        desc: "Supervisión y separación contable por tipo de consumo.",
        pendingNotice: "Módulo en fase de activación. Desglosará con precisión el consumo real en tres partidas independientes: Razonamiento LLM, Generación de Imagen y Generación de Vídeo.",
        bucket1: "Consumo Creative Director (Tokens LLM)",
        bucket2: "Consumo Generación de Imágenes",
        bucket3: "Consumo Generación de Vídeos",
      },
      logs: {
        title: "Registros de auditoría",
        desc: "Historial de operaciones de infraestructura y seguridad.",
        pendingNotice: "Módulo en fase de activación. Registrará eventos de conexión y cambios administrativos sin exponer credenciales.",
      },
    },
    pendingTag: "Pendiente de activación",
  },
  continuity: {
    title: "Inspector de Continuidad",
    subtitle: "Supervisión interactiva de raccord cinematográfico y coherencia narrativa.",
    disclaimer: "Inspección textual de prompts y canon · Sin análisis de píxeles ni visión artificial",
    categories: {
      real_contradiction: "Contradicción real",
      possible_risk: "Posible riesgo",
      missing_information: "Información faltante",
      registered_unused_asset: "Referencia no utilizada",
    },
    filterAll: "Todo el proyecto",
    filterScene: "Esta escena",
    filterPending: "Pendientes",
    filterDecided: "Decididas",
    pendingCount: (n) => `${n} pendiente${n === 1 ? "" : "s"}`,
    noObservations: "Sin observaciones de continuidad detectadas.",
    noSceneObservations: "Sin observaciones pendientes para esta escena.",
    cleanState: "No se detectaron contradicciones en la información revisada",
    cleanStateDesc: "El análisis revisa texto y metadatos; esto no garantiza continuidad visual de los fotogramas generados.",
    affectedScenes: "Escenas afectadas",
    evidence: "Evidencia de raccord",
    canonSource: "Fuente canónica",
    recommendation: "Recomendación consultiva",
    proposedChange: "Propuesta de corrección",
    beforeText: "Antes (actual)",
    afterText: "Después (propuesto)",
    applyProposal: "Aplicar cambio propuesto",
    appliedSuccess: "Cambio propuesto aplicado a la escena.",
    markReviewed: "Marcar como revisada",
    dismiss: "Descartar",
    restore: "Restaurar a pendiente",
    statusReviewed: "Revisada",
    statusDismissed: "Descartada",
    statusApplied: "Aplicada",
    attentionTitle: "Requieren atención",
    informativeTitle: "Información de reparto y notas consultivas",
    possibleUnlinkedRef: "Posible referencia sin vincular",
    helpTitle: "Guía de acciones",
    filterSceneHint: "Cambia el alcance para mostrar solo las observaciones de la escena actual.",
    filterAllHint: "Cambia el alcance para mostrar las observaciones de todo el proyecto.",
    filterPendingHint: "Filtra por observaciones pendientes de revisar.",
    filterDecidedHint: "Filtra por observaciones con decisión tomada.",
    markReviewedHint: "Registra que se revisó la observación; no modifica el prompt ni aprueba la toma.",
    dismissHint: "Aparta la observación sin modificar la escena.",
    restoreHint: "Devuelve la observación a pendientes.",
    applyProposalHint: "Modifica el prompt con el texto propuesto, únicamente mediante tu acción explícita.",
    restoreTitle: "Restaurar",
    applyProposalTitle: "Aplicar propuesta",
    requestFix: "Solicitar corrección",
    requestFixHint: "Prepara un borrador en el chat del Asistente vinculado a esta toma para corregir la inconsistencia.",
    analysisScope: "Alcance del análisis",
    singleSceneReviewedBrief: "Texto revisado sin inconsistencias internas.",
    viewFullPrompt: "Ver texto completo",
    hideFullPrompt: "Ocultar texto",
    collapseInformative: "Plegar información y notas",
  },
};

export default es;
